import React, { createContext, PropsWithChildren, useContext } from 'react'
import { FilePreviewProps } from './types'

type FilePreviewProviderProps = Pick<
  FilePreviewProps,
  'aspectRatio' | 'file' | 'onClick' | 'onDelete' | 'renderPreview' | 'isLoading'
> &
  PropsWithChildren

const FilePreviewContext = createContext<FilePreviewProviderProps | undefined>(undefined)

export const useFilePreview = () => {
  const context = useContext(FilePreviewContext)
  if (!context) {
    throw new Error('useFilePreview must be used within a FilePreviewProvider')
  }

  return context
}

export const FilePreviewProvider: React.FC<FilePreviewProviderProps> = ({
  children,
  ...contextValue
}) => {
  return <FilePreviewContext.Provider value={contextValue}>{children}</FilePreviewContext.Provider>
}
